import { FirebaseApp } from 'firebase/app';
import { Firestore, getFirestore, doc, getDoc, setDoc } from 'firebase/firestore';
import { IImportDatesService } from '../IImportDatesService';
import { ImportDates } from '../../model/ImportDates';

export class ImportDatesService implements IImportDatesService {
  private database: Firestore;
  private path: string = '';

  constructor(app: FirebaseApp, path: string) {
    this.database = getFirestore(app);
    this.path = path;
  }

  async getLastImportDates(): Promise<ImportDates> {
    const ref = doc(this.database, this.path);
    const snapshot = await getDoc(ref);
    if(snapshot.exists()) {
      return snapshot.data() as ImportDates;
    }
    return { sales: 0 };
  }

  async saveLastImportDates(dates: ImportDates): Promise<void> {
    const ref = doc(this.database, this.path);
    await setDoc(ref, dates);
  }
}
